module.exports = __webpack_public_path__ + "img/已完成.c962e4cc.svg";